import React from 'react';
import { Tooltip } from '@mui/material';

const PlainTooltip = ({
  title,
  children,
  placement = "top",
  arrow = false,
  enterDelay = 500,
  leaveDelay = 200,
  sx = {}
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow={arrow}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: 'white',
            fontSize: '0.75rem',
            maxWidth: 200,
            ...sx
          }
        }
      }}
    >
      {children}
    </Tooltip>
  );
};

export default PlainTooltip;
